<div class="p-7 w-[400px] max-w-[90vw]">
  <p class="text-[16px] font-bold text-[var(--base-text-alt-dark)] m-0 mb-1">{{data?.isLabManagerComp ? 'File' : 'Order'}} Attachment</p>
  <p class="text-sm text-[var(--tertiary-text)] mb-5">Add an attachment to {{data?.isLabManagerComp ? 'lab result' : 'this order'}}.</p>

  <form [formGroup]="newAttachmentForm">
    <mat-form-field class="w-full" appearance="outline">
      <mat-label>File Description</mat-label>
      <input matInput oninput="if (this.value.length > 100) this.value = this.value.slice(0, 100);" formControlName="description">
    </mat-form-field>

    <div class="bg-[var(--app-base)] rounded-lg px-4 py-4 mb-4 flex flex-col items-center gap-3">
      <input type="file" #fileInput hidden (change)="selectNewAttachment($event)">
      <button (click)="fileInput.click()" type="button"
        class="py-1.5 px-4 border-none rounded-lg text-[12px] font-semibold bg-[var(--primary-dark)] text-white cursor-pointer flex items-center gap-1.5 hover:opacity-90 transition-all">
        <span class="material-icons text-[16px]">attach_file</span> ATTACH
      </button>
      <div *ngIf="fileName" class="flex items-center text-[12px]">
        <span class="font-bold text-[var(--base-text-alt-dark)] mr-1.5">File Name:</span>
        <span class="text-[var(--tertiary-text)]">{{fileName}}</span>
      </div>
    </div>

    <div class="flex justify-end gap-3 mt-4">
      <button (click)="cancelAddingAttachment()" type="button" class="px-5 py-2.5 rounded-lg text-[13px] font-medium text-[var(--base-text-alt-dark)] hover:bg-[var(--app-base)] transition">Cancel</button>
      <button (click)="uploadNewAttachment()" type="button" class="px-5 py-2.5 rounded-lg text-[13px] font-medium bg-[var(--primary-dark)] text-white hover:opacity-90 transition">Upload</button>
    </div>
  </form>
</div>
